import React from 'react'

const FAQPage = () => {
  return (
    <div>
      FAQs regarding the App
    </div>
  )
}

export default FAQPage
